import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

interface ProjectNavigationProps {
  href: string;
}

export function ProjectNavigation({ href }: ProjectNavigationProps) {
  return (
    <div className="text-center py-20">
      <Link to={href}>
        <div className="inline-flex items-center text-lg group">
          <ArrowRight className="h-6 w-6 text-white transform group-hover:translate-x-2 transition-transform duration-300" />
        </div>
      </Link>
    </div>
  );
}
